/** Artifacts — edit form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  ARTIFACT_TYPES,
  ARTIFACT_STATUS,
  PRIORITY,
  updateArtifactSchema,
  type Artifact,
  type UpdateArtifactInput,
} from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader, LoadingState, ErrorState } from "../projects/_shared";
import {
  FormGrid,
  SelectField,
  TextAreaField,
  TextField,
} from "../projects/_form";

export function ArtifactEdit() {
  const form = useForm<Artifact, any, UpdateArtifactInput>({
    resolver: zodResolver(updateArtifactSchema),
    refineCoreProps: { resource: "artifacts", action: "edit" },
  });

  const {
    refineCore: { formLoading, query },
    saveButtonProps,
    control,
  } = form;

  if (query?.isLoading) return <LoadingState label="Loading artifact…" />;
  if (query?.isError) return <ErrorState error={query.error} />;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader title="Edit Artifact" description="Update artifact details." />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Artifact details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <TextField control={control} name="title" label="Title" />
              <FormGrid>
                <SelectField
                  control={control}
                  name="artifact_type"
                  label="Type"
                  options={ARTIFACT_TYPES}
                />
                <SelectField
                  control={control}
                  name="status"
                  label="Status"
                  options={ARTIFACT_STATUS}
                />
                <SelectField
                  control={control}
                  name="priority"
                  label="Priority"
                  options={PRIORITY}
                />
                <TextField
                  control={control}
                  name="due_date"
                  label="Due date"
                  type="date"
                />
                <TextField
                  control={control}
                  name="project_id"
                  label="Project ID"
                />
                <TextField
                  control={control}
                  name="owner_user_id"
                  label="Owner User ID"
                />
                <TextField
                  control={control}
                  name="source_system"
                  label="Source system"
                />
                <TextField
                  control={control}
                  name="external_url"
                  label="External URL"
                />
              </FormGrid>
              <TextAreaField
                control={control}
                name="description"
                label="Description"
              />
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Saving…" : "Save Changes"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default ArtifactEdit;
